//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the Rock.CodeGeneration project
//     Changes to this file will be lost when the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

/** Represents the preferred resolution of the binary file type. */
export const Resolution = {
    /** The undefined. */
    Undefined: -1,

    /** A preferred resolution of 72 DPI. */
    DPI72: 0,

    /** A preferred resolution of 150 DPI. */
    DPI150: 1,

    /** A preferred resolution of 300 DPI. */
    DPI300: 2,

    /** A preferred resolution of 600 DPI. */
    DPI600: 3
} as const;

/** Represents the preferred resolution of the binary file type. */
export const ResolutionDescription: Record<number, string> = {
    [-1]: "Undefined",

    0: "DPI72",

    1: "DPI150",

    2: "DPI300",

    3: "DPI600"
};

/** Represents the preferred resolution of the binary file type. */
export type Resolution = typeof Resolution[keyof typeof Resolution];
